import { render, staticRenderFns } from "./index_file_word.html?vue&type=template&id=490db746&"
import script from "./ImportQuestionFileWord.vue?vue&type=script&lang=js&"
export * from "./ImportQuestionFileWord.vue?vue&type=script&lang=js&"
import style0 from "./ImportQuestionFileWord.vue?vue&type=style&index=0&id=490db746&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports